module.exports = __webpack_public_path__ + "common/icon-arrow-right-25022004b41b4048e5723fa8858f4d88.svg";